import '../../../scss/common/components/planner-selection.scss'

import { Display3, Card, Link } from '@sainsburys-tech/fable'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { setUserPreferredPlanner } from '../../api/plannerApi'
import { useApiClient } from '../../AppContext/appContext'
import { IPlannerSelectionCard } from '../../types/IPlannerSelectionCard'
import SelectFavoriteModal from '../Modals/SelectFavoriteModal'

const PlannerSelectionCard = (props: IPlannerSelectionCard) => {
  const [selectedPlanner, setSelectedPlanner] = useState(-1)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const apiClient = useApiClient()
  const navigate = useNavigate()

  const openModal = (planner: number) => {
    if (planner !== -1) {
      setIsModalOpen(true)
      setSelectedPlanner(planner)
    }
  }

  const onModalYes = () => {
    if (selectedPlanner !== -1) {
      setUserPreferredPlanner(apiClient, selectedPlanner)
        .then((res) => {
          if (!res) {
            navigate('/error')
          }
        })
        .catch(() => {
          navigate('/error')
        })
    }
  }

  const onModalNo = () => {
    setIsModalOpen(false)
  }

  const onModalClose = () => {
    setSelectedPlanner(-1)
    setIsModalOpen(false)
  }

  const cardBody = () => (
    <div
      className='planner-selection-card-content'
      data-testid={`card${props.plannerType}`}
    >
      <img
        title={`${props.plannerName}`}
        className='c-selection-image'
        src={props.plannerIcon}
        alt={`planner ${props.plannerName}`}
      />
      <Display3>{props.plannerName}</Display3>
    </div>
  )

  return (
    <>
      <Card
        orientation='vertical'
        className={`c-card
            ${selectedPlanner === props.plannerType ? 'c-orange-border' : 'c-unselected-border'}
            ${props.disabled ? 'c-disabled-card' : ''}`}
      >
        {props.disabled ? (
          cardBody()
        ) : (
          <Link
            data-testid={`link${props.plannerType}`}
            onClick={() => openModal(props.plannerType)}
            className='c-common-hover-over-cursor'
          >
            {cardBody()}
          </Link>
        )}
      </Card>
      <SelectFavoriteModal
        {...{
          isOpen: isModalOpen,
          linkpath: props.linkPath,
          modalBody:
            "You'll go straight to this planner when you sign in. " +
            'You can switch planner in settings at any time.',
          modalNo: 'No',
          modalTitle: 'Make this your favourite planner?',
          modalYes: 'Yes, make favourite planner',
          onClose: onModalClose,
          onNo: onModalNo,
          onYes: onModalYes,
        }}
      />
    </>
  )
}

export default PlannerSelectionCard
